import React from "react";
import {PropTypes} from 'prop-types';
import Rating from "../../components/Rating";
import {getTranslation} from '../../translations/translationUtils';
import If from '../../components/If';
import Checkbox from "../../components/Checkbox";
import TextInputWithLabel from "../../components/TextInputWithLabel";
import Dropdown from "../../components/Dropdown";
import TextAreaWithLabel from "../../components/TextAreaWithLabel";
import {connect} from "react-redux";

function renderQuestion(question) {
    const title = question.type === "field" ? question.title : question.question;
    return(
        <>
            <span>{getTranslation(title)}</span>
            {/* {question.mandatory && <span className="text-red mr-1"> *</span>} */}
        </>
    )
}

class FeedbackForm extends React.Component {
    constructor() {
        super();
        this.state = {
            id: null,
            fieldEditors: null,
            answerTextEditors: null,
            answerRatingEditors: null,
            hasRatings: false,
            isValid: false,
            amountSubmitPressed: 0
        };
    }

    componentDidMount() {
        let profile = this.props.profile;
        if (profile != null) {
            this.setState(this._initEditors(profile), () => {
                if (this.props.onValidChanged != null) {
                    this.props.onValidChanged(this.state.isValid);
                }
            });
        }
    }

    componentDidUpdate() {
        if (this.props.amountSubmitPressed) {
            if (this.state.amountSubmitPressed !== this.props.amountSubmitPressed) {
                const missingMessagesElements = document.getElementsByClassName("feedbackMandatoryMissing");
                if (missingMessagesElements.length > 0) {
                    const firstMssingMessage = missingMessagesElements[0];
                    firstMssingMessage.scrollIntoView();

                    let pxScrollBy = -80;
                    if (firstMssingMessage.previousElementSibling.type === "textarea") {
                        pxScrollBy = -280;
                    }
                    window.scrollBy(0, pxScrollBy);
                }
                this.setState({amountSubmitPressed: this.props.amountSubmitPressed});
            }
        }
    }

    _initEditors(profile) {
        let hasRatings = false;
        let answerTextEditors = {};
        let answerRatingEditors = {};
        let fieldEditors = {};

        for (let field of profile.fields) {
            fieldEditors[field.id] = {
                editValue: "",
                mandatory: field.mandatory != null ? field.mandatory : true
            };
            if (field.multipleChoice) {
                fieldEditors[field.id].selectedValues = [];
            }
        }
        for (let question of profile.questions) {
            if (question.inputText) {
                answerTextEditors[question.id] = {
                    editValue: "",
                    mandatory: question.mandatory != null ? question.mandatory : true,
                    inputTextSmall: question.inputTextSmall
                };
            }
            if (question.inputRating) {
                hasRatings = true;
                answerRatingEditors[question.id] = {
                    editValue: null,
                    mandatory: question.mandatory != null ? question.mandatory : true
                };
            }
        }
        return {
            id: profile.id,
            fieldEditors: fieldEditors,
            answerTextEditors: answerTextEditors,
            answerRatingEditors: answerRatingEditors,
            hasRatings: hasRatings,
            isValid: this._validate(fieldEditors, answerRatingEditors, answerTextEditors)
        }
    }

    _validate(fieldEditors, answerRatingEditors, answerTextEditors) {
        let profile = this.props.profile;
        if (profile === null) {
            return false;
        }
        const fieldsValid = !profile.fields.some((field) => {
            const fieldInvalid = this.getIsMandatoryFieldMissing(fieldEditors[field.id]);
            return fieldInvalid;
        });

        const questionsValid = !profile.questions.some((question) => {
            const isMandatoryQuestionMissing = this.getIsMandatoryQuestionMissing(question, answerRatingEditors[question.id], answerTextEditors[question.id]);
            const isTextLimitsExceeded = this.getIsTextLimitExceeded(question, answerRatingEditors[question.id], answerTextEditors[question.id]);
            return isMandatoryQuestionMissing || isTextLimitsExceeded;
        });

        return fieldsValid && questionsValid;
    }

    fieldChanged(field, event) {
        const newValue = event.target.value;
        const checked = event.target.checked;
        const selectedStringValue = event.target.name;
        let isValidChanged = false;

        this.setState((prevState) => {
                let fieldEditors = prevState.fieldEditors;

                if (field.multipleChoice) {
                    const prevSelectedValues = fieldEditors[field.id].selectedValues;

                    const newSelectedValues = this.getNewMultipleChoiceValue(prevSelectedValues, selectedStringValue, checked);
                    fieldEditors[field.id].selectedValues = newSelectedValues;
                    fieldEditors[field.id].editValue = newSelectedValues.toString();
                } else {
                    fieldEditors[field.id].editValue = newValue;
                }

                let isValid = this._validate(fieldEditors, prevState.answerRatingEditors, prevState.answerTextEditors);
                isValidChanged = prevState.isValid !== isValid;
                return {fieldEditors: fieldEditors, isValid: isValid};
            }, () => {
                if (isValidChanged && this.props.onValidChanged != null) {
                    this.props.onValidChanged(this.state.isValid);
                }
            });
    }

    getNewMultipleChoiceValue(prevSelectedValues, stringValue, checked) {
        if (checked) {
            prevSelectedValues.push(stringValue);
        } else {
            prevSelectedValues = prevSelectedValues.filter(function(e) { return e !== stringValue })
        }
        return prevSelectedValues;
    }

    answerTextChanged(question, value) {
        let newValue = value;
        let isValidChanged = false;
        this.setState((prevState) => {
            let answerRatingEditors = prevState.answerRatingEditors;
            let answerTextEditors = prevState.answerTextEditors;
            answerTextEditors[question.id].editValue = newValue;
            let isValid = this._validate(prevState.fieldEditors, answerRatingEditors, prevState.answerTextEditors);
            isValidChanged = prevState.isValid !== isValid;
            return {answerTextEditors: answerTextEditors, isValid: isValid};
        }, () => {
            if (isValidChanged && this.props.onValidChanged != null) {
                this.props.onValidChanged(this.state.isValid);
            }
        });
    }

    answerRatingChanged(question, value) {
        let isValidChanged = false;
        this.setState((prevState) => {
                let answerRatingEditors = prevState.answerRatingEditors;
                answerRatingEditors[question.id].editValue = value;
                let isValid = this._validate(prevState.fieldEditors, answerRatingEditors, prevState.answerTextEditors);
                isValidChanged = prevState.isValid !== isValid;
                return {answerRatingEditors: answerRatingEditors, isValid: isValid};
            }, () => {
                if (isValidChanged && this.props.onValidChanged != null) {
                    this.props.onValidChanged(this.state.isValid);
                }
            });
    }

    getFeedbackResult() {
        let profile = this.props.profile;
        if (profile === null) {
            return false;
        }
        let fields = profile.fields.map((field) => ({
            "id": field.id,
            "field": getTranslation(field.title),
            "value": this.state.fieldEditors[field.id].editValue
        }));
        let answers = profile.questions.map((question) => {
            let answer = {"id": question.id};
            if (question.inputText) {
                answer["text"] = encodeURIComponent(this.state.answerTextEditors[question.id].editValue);
            }
            if (question.inputRating) {
                answer["rating"] = this.state.answerRatingEditors[question.id].editValue;
            }
            return answer;
        });
        return {
            "id": profile.id,
            "fields": fields,
            "answers": answers
        }
    }

    getIsMandatoryFieldMissing(fieldEditor) {
        if (fieldEditor.mandatory && (!fieldEditor.editValue || fieldEditor.editValue === "")) {
            return true;
        }
        return false;
    }

    getIsMandatoryQuestionMissing(question, answerRatingEditor, answerTextEditor) {
        if (!question.mandatory) {
            return false;
        }


        if (question.inputRating && question.inputText) {
            if (answerRatingEditor && answerRatingEditor.mandatory && (question.inputRating && (answerRatingEditor.editValue !== null))) {
                return false;
            }
        }

        if (question.inputRating && !question.inputText) {
            if (answerRatingEditor && answerRatingEditor.mandatory && (question.inputRating && (answerRatingEditor.editValue !== null))) {
                return false;
            }
        }

        if (!question.inputRating && question.inputText) {
            if (answerTextEditor && answerTextEditor.mandatory && answerTextEditor.editValue !== "") {
                return false;
            }
        }

        return true;
    }

    getIsTextLimitExceeded(question, _ , answerTextEditor) {
        if(question.inputRating) return false;

        // Text Input
        if(question.inputText && question.inputTextSmall){
            return answerTextEditor.editValue.length > 50
        }

        // Text Area
        if(question.inputText && !question.inputTextSmall){
            return answerTextEditor.editValue.length > 250
        }
    }

    render() {

        let profile = this.props.profile;
        if (profile === null || this.state.id === null) {
            return false;
        }

        if (!this.props.combinedProfile) {
            return false;
        }

        let hasRatings = this.state.hasRatings;

        const mandatoryErrorText = this.context.t("mandatory_answer");

        if(this.props.saved){
            return null;
        }

        return (
            <div>
                {
                    this.props.combinedProfile.items.map((item, itemIdx) => {

                        if (item.type === "field") {
                            const field = item;
                            const fieldIdx = itemIdx;


                            let fieldEditor = this.state.fieldEditors[field.id];
                            return (
                                <div key={fieldIdx} className="row">
                                    <If test={field.multipleChoice}>
                                        <div className="w-full md:w-2/3 xl:w-1/3" key={field.id}>
                                            <div className="feedbackFieldTitle mb-2">
                                                {renderQuestion(field)}
                                            </div>
                                            {field.values.map(fieldValue => (
                                                <Checkbox
                                                    key={fieldValue}
                                                    name={fieldValue}
                                                    label={fieldValue}
                                                    labelClassNames="text-base text-primary"
                                                    indicatorStyle={{ borderColor: '#cacaca' }}
                                                    checked={fieldEditor.selectedValues?.includes(fieldValue)}
                                                    disabled={this.props.saved}
                                                    handleCheckboxChange={(e)=>{
                                                        this.fieldChanged(field, e);
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </If>

                                    <If test={!field.multipleChoice}>
                                        <div className="w-full md:w-2/3 xl:w-1/3">
                                            <Dropdown
                                                title={renderQuestion(field)}
                                                disabled={this.props.saved}
                                                selectedOption={fieldEditor.editValue}
                                                pleaseSelectLabel={this.context.t("feedback_please_select")}
                                                labelClassNames="feedbackFieldTitle text-primary mb-2"
                                                handleChange={(e)=>{
                                                    this.fieldChanged(field, e);
                                                }}
                                                options={field.values.map(fieldValue => ({
                                                    value: fieldValue,
                                                    label: fieldValue
                                                })
                                            )}
                                            />
                                        </div>
                                    </If>

                                    <If test={this.props.amountSubmitPressed > 0 && this.getIsMandatoryFieldMissing(fieldEditor)}>
                                        <div className="feedbackMandatoryMissing">{mandatoryErrorText}</div>
                                    </If>
                                </div>
                            )
                        }

                        if (item.type === "question") {

                            const question = item;
                            const questionIdx = itemIdx;

                            let answerTextEditor = this.state.answerTextEditors[question.id];
                            let answerRatingEditor = this.state.answerRatingEditors[question.id];
                            let answerHeader = hasRatings ? (
                                <div key={questionIdx}>
                                    {answerRatingEditor != null ? (
                                        <div>
                                            <div className="feedbackFieldTitle">
                                                {renderQuestion(question)}
                                            </div>
                                            <Rating
                                                value={answerRatingEditor.editValue > 0 ? answerRatingEditor.editValue : 0}
                                                maxValue={10}
                                                onRatingChanged={(value)=>{
                                                    this.answerRatingChanged(question, value)
                                                }}
                                                disabled={this.props.saved}
                                            />
                                            <If test={this.props.amountSubmitPressed > 0 && !answerTextEditor && this.getIsMandatoryQuestionMissing(question, answerRatingEditor)}>
                                                <div className="feedbackMandatoryMissing">{mandatoryErrorText}</div>
                                            </If>
                                        </div>
                                    ) : false}
                                </div>
                            ) : (<div key={questionIdx}/>);
                            if (answerTextEditor != null) {
                                return [answerHeader, (
                                    <div key={question.id + 'Details'}>
                                        <If test={!question.inputTextSmall}>
                                            <TextAreaWithLabel
                                                label={renderQuestion(question)}
                                                placeholder={this.context.t("feedback_textarea_placeholder")}
                                                rows="5" cols="20"
                                                labelClassNames="feedbackFieldTitle text-base text-primary"
                                                classNames="w-full md:w-2/3 xl:w-1/3"
                                                _onChange={(value)=>{
                                                    this.answerTextChanged(question, value);
                                                }}
                                                value={answerTextEditor.editValue}
                                                disabled={this.props.saved}
                                            />
                                        </If>
                                        <If test={question.inputTextSmall}>
                                            <TextInputWithLabel
                                                label={renderQuestion(question)}
                                                placeholder={this.context.t("feedback_textinput_placeholder")}
                                                labelClassNames="feedbackFieldTitle text-base text-primary"
                                                classNames="w-full md:w-2/3 xl:w-1/3"
                                                type="text"
                                                _onChange={(value)=>{
                                                    this.answerTextChanged(question, value);
                                                }}
                                                value={answerTextEditor.editValue}
                                                disabled={this.props.saved}
                                            />
                                        </If>
                                        <If test={this.getIsTextLimitExceeded(question, answerRatingEditor, answerTextEditor)}>
                                            <div className="feedbackMandatoryMissing">
                                                {question.inputTextSmall ? this.context.t("feedback_textinput_placeholder") : this.context.t("feedback_textarea_placeholder")}
                                            </div>
                                        </If>
                                        <If test={this.props.amountSubmitPressed > 0 && this.getIsMandatoryQuestionMissing(question, answerRatingEditor, answerTextEditor)}>
                                            <div className="feedbackMandatoryMissing">{mandatoryErrorText}</div>
                                        </If>
                                    </div>
                                )];
                            } else {
                                return answerHeader;
                            }

                        }
                        return null;
                    })
                }
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        // lang used to trigger rerender in new language when changed
        lang: state.i18nState.lang
    };
};

FeedbackForm.contextTypes = {
    t: PropTypes.func.isRequired
};

export default connect(mapStateToProps, null, null, {forwardRef: true})(FeedbackForm);
